const env = import.meta.env as Record<string, string | undefined>;

export const DAEMON_URL = (env.VITE_DAEMON_URL ?? "http://localhost:8787").replace(/\/$/, "");
export const DEFAULT_PROJECT = env.VITE_DEFAULT_PROJECT ?? "minimap";

/**
 * The daemon's byte cap on a queued prompt (src/config.ts `messageMaxBytes`,
 * default 100 KB of UTF-8). It applies only to what the queue stores (enqueue
 * and edit); a watched send takes any size. The Composer checks it on the
 * queue path so an oversized prompt keeps its draft instead of failing later.
 */
export const QUEUE_MESSAGE_MAX_BYTES = 102_400;
